import styled from "@emotion/styled";
import { FC } from "react";
import Translate from "components/Translate/Translate";
import BehavioralCrisisHotlinePopup from "./BehavioralCrisisHotlinePopup";
import { PopupDialogTrigger } from "molecule/popupDialog/PopupDialogTrigger";
import { PopupDialogTriggerButton } from "molecule/popupDialog/PopupDialogTriggerButton";

const BehavioralHealthDialogCrisisWrapper = styled.div`
  display: flex;
  width: 100%;
  flex: 0 0 auto;
  flex-flow: column nowrap;
  margin-top: 2.5rem /* 40/16 */;
  align-items: center;
`;

const BehavioralHealthDialogCrisisImmediate = styled.div`
  font-feature-settings:
    "liga" off,
    "clig" off;

  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 22.4px */
  letter-spacing: -0.02rem;

  font-family: var(--font-family-serif);
`;
const BehavioralHealthDialogCrisisTextOrCall = styled.div`
  font-feature-settings:
    "liga" off,
    "clig" off;

  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: -0.018rem;
`;

export const BehavioralHealthDialogCrisis: FC = () => (
  <>
    <BehavioralHealthDialogCrisisWrapper>
      <BehavioralHealthDialogCrisisImmediate>
        <PopupDialogTrigger>
          <PopupDialogTriggerButton>
            <Translate msg={"behavioralHealthDialog_crisis_immediate"} />
          </PopupDialogTriggerButton>
          <BehavioralCrisisHotlinePopup />
        </PopupDialogTrigger>
      </BehavioralHealthDialogCrisisImmediate>
      <BehavioralHealthDialogCrisisTextOrCall>
        <Translate msg={"behavioralHealthDialog_crisis_textOrCall"} />
      </BehavioralHealthDialogCrisisTextOrCall>
    </BehavioralHealthDialogCrisisWrapper>
  </>
);
